import { render } from "./EventDetailsModal.vue?vue&type=template&id=14505458&scoped=true"
import script from "./EventDetailsModal.vue?vue&type=script&lang=js"
export * from "./EventDetailsModal.vue?vue&type=script&lang=js"

import "./EventDetailsModal.vue?vue&type=style&index=0&id=14505458&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14505458"]])

export default __exports__